module.exports = __webpack_public_path__ + "static/street-istanbul-be57dd2d34f3fb1d4fba61cba1061f9f.png";